var map = {
	"./GTR-No-Picture.png": 61655,
	"./bootcamp-2021/bootcamp-2021.jpeg": 80893,
	"./brand/gtr-academy-favicon.ico": 54083,
	"./brand/gtr-academy-favicon.svg": 37978,
	"./brand/gtr-academy-isotipo-color.svg": 52880,
	"./brand/gtr-academy-isotipo-dark.svg": 51194,
	"./brand/gtr-academy-isotipo-white.svg": 13930,
	"./brand/gtr-academy-logo-color-on-dark.svg": 18476,
	"./brand/gtr-academy-logo-color-on-light.svg": 10096,
	"./brand/gtr-academy-logo-dark.svg": 88360,
	"./brand/gtr-academy-logo-vertical-color-on-dark.svg": 8939,
	"./brand/gtr-academy-logo-vertical-color-on-light.svg": 69029,
	"./brand/gtr-academy-logo-vertical-dark.svg": 93271,
	"./brand/gtr-academy-logo-vertical-white.svg": 92127,
	"./brand/gtr-academy-logo-white.svg": 41769,
	"./brand/gtr-evolution-favicon.ico": 90138,
	"./brand/gtr-evolution-favicon.svg": 67371,
	"./brand/gtr-evolution-isotipo-color.svg": 87157,
	"./brand/gtr-evolution-isotipo-dark.svg": 48080,
	"./brand/gtr-evolution-isotipo-white.svg": 1548,
	"./brand/gtr-evolution-logo-color-on-dark.svg": 65797,
	"./brand/gtr-evolution-logo-color-on-light.svg": 57061,
	"./brand/gtr-evolution-logo-dark.svg": 54543,
	"./brand/gtr-evolution-logo-vertical-color-on-dark.svg": 7364,
	"./brand/gtr-evolution-logo-vertical-color-on-light.svg": 95508,
	"./brand/gtr-evolution-logo-vertical-dark.svg": 89645,
	"./brand/gtr-evolution-logo-vertical-white.svg": 72250,
	"./brand/gtr-evolution-logo-white.svg": 19390,
	"./brand/gtr-isotipo-color-on-dark.svg": 37791,
	"./brand/gtr-isotipo-color-on-light.svg": 36495,
	"./brand/gtr-isotipo-dark.svg": 43413,
	"./brand/gtr-isotipo-white.svg": 94814,
	"./brand/gtr-logo-color-on-dark.svg": 67171,
	"./brand/gtr-logo-color-on-light.svg": 82350,
	"./brand/gtr-logo-dark.svg": 33230,
	"./brand/gtr-logo-white.svg": 70018,
	"./btc-loading.gif": 89396,
	"./classes/academy/ai_money.png": 92186,
	"./classes/academy/basicos_binarias.jpg": 39695,
	"./classes/academy/binarias.jpeg": 86293,
	"./classes/academy/cryptospace.jpeg": 79561,
	"./classes/academy/deportes.jpeg": 27625,
	"./classes/academy/english_advanced.png": 76422,
	"./classes/academy/english_basic.png": 46322,
	"./classes/academy/english_interm.png": 93121,
	"./classes/academy/forex.jpeg": 23476,
	"./classes/academy/marketking.jpeg": 11162,
	"./classes/academy/mk_workshop.jpeg": 37634,
	"./classes/default-card.png": 76575,
	"./classes/liderazgo/clase_gratis.png": 97803,
	"./classes/liderazgo/clase_gratis_lap.png": 92291,
	"./classes/liderazgo/fhh.png": 29566,
	"./classes/liderazgo/gtr_woman.png": 73527,
	"./classes/liderazgo/influencers.png": 33001,
	"./classes/liderazgo/inicio_rapido.png": 68930,
	"./classes/liderazgo/mentoria.png": 79137,
	"./classes/liderazgo/mindsetcall.png": 11178,
	"./classes/liderazgo/plan_de_negocios.png": 45724,
	"./classes/liderazgo/testimonios.png": 34870,
	"./classes/liderazgo/wakeup_call.png": 16219,
	"./classes/past/600_y_sup.png": 55545,
	"./classes/past/binarias.png": 39335,
	"./classes/past/binary-options.jpg": 91490,
	"./classes/past/clase_gratis_lap.png": 26921,
	"./classes/past/clase_gratis_libreta.png": 23156,
	"./classes/past/cryptospace.png": 5924,
	"./classes/past/default-card.jpg": 23494,
	"./classes/past/deportes.png": 28115,
	"./classes/past/forex.png": 59263,
	"./classes/past/gtr metal.png": 5634,
	"./classes/past/inicio_rapido.png": 5040,
	"./classes/past/kinder-forex.jpg": 18413,
	"./classes/past/market-analysis.jpg": 39352,
	"./classes/past/marketking.png": 71351,
	"./classes/past/mentoria.png": 73035,
	"./classes/past/mentoria2.png": 6758,
	"./classes/past/mindsetcall.png": 61578,
	"./classes/past/plan_de_negocios.png": 85012,
	"./classes/past/testimonios.png": 88563,
	"./classes/past/trading-deportivo.jpg": 30313,
	"./classes/past/wakeup_call.png": 746,
	"./confetti/Bitcoin-coin-2.png": 18484,
	"./confetti/Bitcoin-vector.png": 95794,
	"./confetti/Bitcoin.png": 74455,
	"./confetti/GTR-Logo-Confetti.png": 9349,
	"./confetti/dia_de_muertos/altar-de-muertos-1.png": 4310,
	"./confetti/dia_de_muertos/altar-de-muertos-2.png": 56759,
	"./confetti/dia_de_muertos/altar-de-muertos-3.png": 69376,
	"./confetti/dia_de_muertos/altar-de-muertos-4.png": 87285,
	"./confetti/dia_de_muertos/altar-de-muertos-vela.png": 68652,
	"./confetti/dia_de_muertos/altar-de-muertos-velas-2.png": 64806,
	"./confetti/dia_de_muertos/altar-de-muertos-velas-3.png": 77066,
	"./confetti/dia_de_muertos/calaverita-1.png": 91959,
	"./confetti/dia_de_muertos/calaverita.png": 13126,
	"./confetti/dia_de_muertos/catrina-1.png": 5644,
	"./confetti/dia_de_muertos/catrina-2.png": 41119,
	"./confetti/dia_de_muertos/catrina-3.png": 84457,
	"./confetti/dia_de_muertos/skeleton.png": 79456,
	"./confetti/halloween/bat-halloween.png": 40914,
	"./confetti/halloween/bitcoin-halloween.png": 8691,
	"./confetti/halloween/dracula-halloween.png": 2826,
	"./confetti/halloween/ghost-halloween.png": 50729,
	"./confetti/halloween/halloween-pumpkin_1.png": 71100,
	"./confetti/halloween/halloween-pumpkin_2.png": 52796,
	"./confetti/halloween/halloween-witch.png": 54109,
	"./confetti/halloween/halloween.png": 75973,
	"./confetti/halloween/witch.png": 5875,
	"./confetti/halloween/zombie.png": 36635,
	"./confetti/mexico/image-1.png": 49587,
	"./confetti/mexico/image-2.png": 14691,
	"./confetti/mexico/image-3.png": 69663,
	"./confetti/mexico/image-4.png": 22505,
	"./confetti/mundial_2026/btc_ball.png": 50066,
	"./confetti/mundial_2026/btc_stadium.png": 45864,
	"./confetti/mundial_2026/fwc_trophy.png": 22967,
	"./confetti/mundial_2026/red_btc_ball.png": 26704,
	"./confetti/mundial_2026/red_gloves.png": 99183,
	"./confetti/newYear/image-1.png": 36449,
	"./confetti/newYear/image-2.png": 6833,
	"./confetti/newYear/image-3.png": 30157,
	"./confetti/newYear/image-4.png": 65881,
	"./confetti/originals/Bitcoin-coin-2.png": 8555,
	"./confetti/originals/Bitcoin-vector.png": 59773,
	"./confetti/originals/GTR-Logo-Confetti.png": 4281,
	"./confetti/originals/dia_de_muertos/altar-de-muertos-1.png": 4574,
	"./confetti/originals/dia_de_muertos/altar-de-muertos-2.png": 77424,
	"./confetti/originals/dia_de_muertos/altar-de-muertos-3.png": 2385,
	"./confetti/originals/dia_de_muertos/altar-de-muertos-4.png": 50717,
	"./confetti/originals/dia_de_muertos/altar-de-muertos-vela.png": 24609,
	"./confetti/originals/dia_de_muertos/altar-de-muertos-velas-2.png": 2935,
	"./confetti/originals/dia_de_muertos/altar-de-muertos-velas-3.png": 28993,
	"./confetti/originals/dia_de_muertos/calaverita-1.png": 91301,
	"./confetti/originals/dia_de_muertos/calaverita.png": 2751,
	"./confetti/originals/dia_de_muertos/catrina-1.png": 76797,
	"./confetti/originals/dia_de_muertos/catrina-2.png": 44873,
	"./confetti/originals/dia_de_muertos/catrina-3.png": 17678,
	"./confetti/originals/dia_de_muertos/skeleton.png": 67273,
	"./confetti/originals/halloween/bat-halloween.png": 65716,
	"./confetti/originals/halloween/bitcoin-halloween.png": 15906,
	"./confetti/originals/halloween/dracula-halloween.png": 57723,
	"./confetti/originals/halloween/ghost-halloween.png": 48334,
	"./confetti/originals/halloween/halloween-pumpkin_1.png": 71005,
	"./confetti/originals/halloween/halloween-pumpkin_2.png": 80509,
	"./confetti/originals/halloween/halloween-witch.png": 76179,
	"./confetti/originals/halloween/halloween.png": 38989,
	"./confetti/originals/halloween/witch.png": 22293,
	"./confetti/originals/halloween/zombie.png": 17009,
	"./confetti/originals/mexico/personaje-femenino-de-bailarina-mexicana.png": 78469,
	"./confetti/originals/mexico/personaje-masculino-mariachi-mexicano.png": 27741,
	"./confetti/originals/mexico/png.monster-955.png": 41760,
	"./confetti/originals/mexico/pngegg.png": 41480,
	"./confetti/originals/mexico/vecteezy_mexico-flat-rounded-flag-with-transparent-background_16328596_916.png": 85750,
	"./confetti/originals/mexico/vecteezy_mexico-waving-flag-realistic-transparent-background_15309672_273.png": 64252,
	"./confetti/originals/mudial_2026/btc_ball.png": 30047,
	"./confetti/originals/mudial_2026/btc_stadium.png": 79634,
	"./confetti/originals/mudial_2026/fwc_trophy.png": 74977,
	"./confetti/originals/mudial_2026/icons_set.png": 31333,
	"./confetti/originals/mudial_2026/red_btc_ball.png": 25632,
	"./confetti/originals/mudial_2026/red_gloves.png": 7116,
	"./confetti/originals/newYear/image-1.png": 12048,
	"./confetti/originals/newYear/image-2.png": 66854,
	"./confetti/originals/newYear/image-3.png": 26133,
	"./confetti/originals/newYear/image-4.png": 37742,
	"./confetti/originals/newYear/new_year_sign.png": 33735,
	"./confetti/originals/reyes/image-1.png": 20000,
	"./confetti/originals/reyes/image-2.png": 85774,
	"./confetti/originals/reyes/image-3.png": 42909,
	"./confetti/originals/reyes/image-4.png": 69288,
	"./confetti/originals/valentines/vecteezy_red-heart-shape-icon-like-or-love-symbol-for-valentine-s_18842780_66.png": 24501,
	"./confetti/originals/valentines/vecteezy_transparent-valentine-icon_11729443_39.png": 13573,
	"./confetti/originals/valentines/vecteezy_watercolor-heart-arrow-happy-valentine-s-day-clipart_11026640_677.png": 63407,
	"./confetti/originals/valentines/vecteezy_watercolor-heart-arrow-happy-valentine-s-day-clipart_11026774_128.png": 42826,
	"./confetti/originals/valentines/vecteezy_watercolor-heart-arrow-happy-valentine-s-day-clipart_11026776_764.png": 38173,
	"./confetti/originals/valentines/vecteezy_watercolor-valentine-s-day-clipart-heart-love-digital_9693934_597.png": 28209,
	"./confetti/originals/valentines/vecteezy_watercolor-valentine-s-day-clipart-heart-love-digital_9693936_706.png": 37220,
	"./confetti/reyes/image-1.png": 76961,
	"./confetti/reyes/image-2.png": 60783,
	"./confetti/reyes/image-3.png": 16549,
	"./confetti/reyes/image-4.png": 94788,
	"./confetti/valentines/image-1.png": 29095,
	"./confetti/valentines/image-2.png": 76044,
	"./confetti/valentines/image-3.png": 99468,
	"./confetti/valentines/image-4.png": 77484,
	"./confetti/xmas/cane.png": 91550,
	"./confetti/xmas/hat.png": 26722,
	"./confetti/xmas/snowflake-1.png": 43463,
	"./confetti/xmas/snowflake-2.png": 48969,
	"./emoji/astonished-face.svg": 4439,
	"./emoji/colombia-flag.svg": 39084,
	"./flags_shine_16x16_sprite.png": 45492,
	"./green-tick.gif": 95778,
	"./gtr-black-16x42.png": 37358,
	"./gtr-evolution-isotipo-dark.svg": 48852,
	"./gtr-evolution-isotipo-white.svg": 99254,
	"./gtr-white-16x42.png": 76350,
	"./gtr_academy-300x115.png": 76406,
	"./gtr_academy_logo-100x120.png": 96325,
	"./gtr_g_blanca.png": 98101,
	"./gtr_g_blanco_rojo.png": 25851,
	"./gtr_g_negra.png": 17431,
	"./gtr_g_negro_rojo.png": 54728,
	"./gtr_metal-300x115.png": 62897,
	"./loading.gif": 60265,
	"./login_bg.png": 52729,
	"./logo-gtr-white.png": 84839,
	"./profile-blue.png": 72126,
	"./purple-spinner.svg": 69051
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25459;